module.exports = __webpack_public_path__ + "img/rating-page-slider-mobile-4.06902d46.png";